import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import InputSelect from '../../components/InputGroup/InputSelect';
import MobileInput from '../../components/InputGroup/MobileInput';
import PhoneInput from 'react-phone-input-2';
import { getBrokerCompanies, requestCompanySignup } from '../../services/private/site-visit.service';
import Banner from './Banner';
import { ReactComponent as LeftArrowIcon } from '../../assets/plus_icon/leftArrow.svg';
import { toast } from 'react-toastify';

const CPRegistration = ({
    setChannelPartner,
    isWithCP,
    ownerName,
    setOwnerName,
    ownerMobile,
    setOwnerMobile,
    email,
    setEmail,
    name,
    setName,
    mobile,
    setMobile,
    companyName,
    setCompanyName,
    setCompanyId,
    projectName,
    setShowMobileField,
    showMobileField
}) => {
    const [error, setError] = useState('');
    const [ownerMobileError, setOwnerMobileError] = useState(false);
    const [mobileError, setMobileError] = useState(false);
    const [companyError, setCompanyError] = useState('');
    const [designation, setDesignation] = useState('employee')
    const [companyList, setCompanyList] = useState([]);
    const [showList, setShowList] = useState(false);

    const nameRef = useRef();;

    const handleMouseClick = (e) => {
        if (nameRef.current && !nameRef.current.contains(e.target)) {
            setShowList(false)
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleMouseClick)
        return (() => document.removeEventListener('mousedown', handleMouseClick))
    }, [])
    const getCompany = async (text) => {
        setCompanyName(text);
        const res = await getBrokerCompanies(text);
        if (res.data.status === 200) {
            setCompanyList(res.data.data);
            if (res.data.data.length > 0) {
                setShowList(true);
            }
        }
    }
    const handleSubmit = async () => {
        if (!name || !mobile || !ownerName || !ownerMobile || !companyName) {
            setError(true);
            return
        } else {
            setError(false)
        }
        if (mobile.length < 12) {
            setMobileError(true);
            return;
        } else {
            setMobileError(false)
        }
        if (showMobileField && ownerMobile.length < 12) {
            setOwnerMobileError(true);
            return;
        } else {
            setOwnerMobileError(false)
        }
        // const payload = {
        //     name: name,
        //     mobile: mobile,
        //     owner_name: ownerName,
        //     owner_mobile: ownerMobile,
        //     company_name: companyName,
        //     email: email
        // }
        // try {
        //     const res = await requestCompanySignup(payload)
        //     if (res.data.status === 200) {
        //         toast.success(res.data.message);
        //         setChannelPartner('5')
        //     }
        // } catch (err) {
        //     toast.error(err.response.data.message);
        //     if (err.response.data.message === "You've already invited this company") {
        //         setChannelPartner('5')
        //     }
        //     setCompanyError(err.response.data.message)
        // }
        setChannelPartner('5')
        // // setChannelPartner('7')
        // setChannelPartner('10')

    }

    return (
        <div className=' mx-auto overflow-auto'>
            {/* <div className='!w-full broker-info'>
                <Banner />
            </div> */}
            <div className='flex items-center justify-center bg-white rounded-xl !my-3 sm:!my-6 !py-6 sm:!py-12 !px-5 sm:!px-10 lg:!px-20 relative'>
                <div className='absolute !top-4 sm:top-5 left-0 bg-gradient-to-r from-[#344054]/100 to-[#66666600] w-[150px] sm:w-[253px]'>
                    <div className='text-white text-xs sm:text-lg font-semibold py-1 pl-1 sm:!py-3 sm:!pl-3'>
                        {projectName}
                    </div>
                </div>
                {/* <button className='flex items-center  absolute left-4 md:left-12' onClick={() => setChannelPartner('4')}>
                    <LeftArrowIcon className='stroke-black800 rotate-180 mr-1' /> <span className='hidden sm:inline-block'>Back</span>
                </button> */}
                <p className='flex flex-col sm:flex-row text-lg sm:text-2xl font-semibold mb-0'>
                    Register Channel Partner
                </p>
            </div>
            <div className=' bg-white rounded-xl !mt-6 !p-4 md:!p-12 '>
                <div className='sm:!mt-6 space-y-4 sm:space-y-6'>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Company Name<sup className='text-red'>*</sup></label>
                            <input
                                className={`border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={'Enter CP Firm Name'}
                                name='company'
                                autoComplete='off'
                                value={companyName}
                                onChange={(e) => getCompany(e.target.value)}
                            />
                            {error && !companyName && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter CP Firm</div>
                            )}
                            {companyName && showList && <div ref={nameRef} className='absolute !top-24 !rounded-lg max-h-[200px] overflow-auto bg-white w-100 z-10 shadow !px-4'>
                                {
                                    companyList?.map((item, index) => (
                                        <div className='flex flex-col sm:!text-lg text-sm !border-b !py-2 cursor-pointer' key={item.uuid}
                                            onClick={() => {
                                                console.log(item, 'item')
                                                setCompanyName(item.company_name)
                                                setOwnerName(item.owner_name)
                                                setOwnerMobile(item?.owner_mobile)
                                                setShowMobileField(false);
                                                setCompanyId(item.id)
                                                setShowList(false)
                                            }}>
                                            <span className='font-semibold text-black-t'>{item.company_name}</span>
                                            <span className='text-grey-500 text-xs'>{item.owner_name}</span>
                                        </div>
                                    ))
                                }
                                <div>
                                </div>
                            </div>}
                        </div>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Owner Name <sup className='text-red'>*</sup></label>
                            <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={`${designation === 'owner' ? 'Enter Your Name' : 'Enter Owner Name'}`}
                                name='company'
                                value={ownerName}
                                onChange={(e) => setOwnerName(e.target.value)}
                            />
                            {error && !ownerName && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Owner Name</div>

                            )}
                        </div>
                    </div>
                    <div className='w-full flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-6'>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Your Name<sup className='text-red'>*</sup></label>
                            <input
                                className={`border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={'Enter Your Name'}
                            />
                            {error && !name && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Your Name</div>

                            )}
                        </div>
                        <div className={`flex flex-col font-medium relative w-full sm:w-1/2`}>
                            <label className='sm:!text-lg text-base !mb-3 '>Your Mobile No.<sup className='text-red'>*</sup></label>

                            <PhoneInput
                                inputClass={'border !w-full !font-medium focus:outline-none focus:border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                                // containerClass={classname}
                                country={'in'}
                                value={mobile}
                                countryCodeEditable={false}
                                enableSearch={true}
                                disableSearchIcon={true}
                                onChange={phone => {
                                    setMobile(phone)
                                }}
                            />
                            {error && !mobile && (
                                <div className="text-red sm:!text-sm text-xs !mt-4">Please Your Mobile No.</div>
                            )}
                            {
                                mobileError && mobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                            }
                        </div>
                    </div>


                    <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Owner Mobile No.<sup className='text-red'>*</sup></label>

                        {showMobileField && <PhoneInput
                            inputClass={'border !w-full !font-medium focus:outline-none focus:border-primary rounded-xl text-input !h-[38px] sm:!h-[54px] text-sm sm:!text-base sm:placeholder:!text-base placeholder:!text-sm  !py-2 sm:!py-3'}
                            // containerClass={classname}
                            country={'in'}
                            value={ownerMobile}
                            countryCodeEditable={false}
                            enableSearch={true}
                            disableSearchIcon={true}
                            onChange={phone => {
                                setOwnerMobile(phone)
                            }}
                        />}
                        {
                            !showMobileField && <input
                                className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                                type={"text"}
                                placeholder={`Enter Your Name`}
                                name='company'
                                value={ownerMobile}
                                //  onChange={(e) => setOwnerName(e.target.value)}
                                disabled={true}
                            />
                        }
                        {error && !ownerMobile && (
                            <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Owner Mobile No.</div>

                        )}
                        {
                            ownerMobileError && ownerMobile && <div className="text-red sm:!text-sm text-xs !mt-4">Please Enter Valid Mobile No.</div>
                        }
                        {
                            companyError && <div className="text-red sm:!text-sm text-xs !mt-4">{companyError}</div>
                        }
                    </div>
                    <div className={`flex flex-col font-medium relative w-full`}>
                        <label className='sm:!text-lg text-base !mb-3 '>Email (optional)</label>

                        <input
                            className={` border rounded-xl focus:outline-none focus:!border-primary  text-input sm:!text-lg text-sm placeholder:sm:!text-lg placeholder:!text-sm !py-2 !px-2 sm:!py-3 sm:!px-4`}
                            type={"text"}
                            placeholder={'Enter Email'}
                            name='company'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />

                    </div>
                </div>

                <div className='w-full justify-center !mt-6 sm:!mt-20 flex flex-col-reverse sm:flex-row items-center sm:space-x-6 space-y-4 space-y-reverse sm:space-y-0'>

                    <button
                        className='w-full sm:w-[1/2] text-base sm:!text-lg border rounded-xl !py-2 sm:!py-3.5' onClick={() => {
                            setName('');
                            setCompanyName('');
                            setMobile('');
                            setOwnerName('');
                            setOwnerMobile('');
                            setEmail('');
                            setChannelPartner('2');
                            setCompanyId('');
                        }}>Back</button>
                    <button className='w-full sm:w-[1/2] text-base sm:!text-lg rounded-xl !py-2 sm:!py-3.5 bg-blue-900 text-white' onClick={() => {
                        if (designation === 'owner') {
                            setName('');
                            setMobile('');
                        }
                        handleSubmit()
                    }}>Next</button>

                </div>
            </div>

        </div>


    )
}

export default CPRegistration